export default "__VITE_ASSET__BRkDldPr__"